import getInstance from "../config/api";
import { sortFiltersByText } from "../utils/sort";

// Cache para enums
const enumCache = new Map();

export default class Enum {
  /**
   * Busca um enum específico com cache
   * @param {string} enumName - Nome do enum (ex: 'ProfileType', 'ContractStatus')
   * @param {boolean} forceRefresh - Força busca no servidor mesmo se já estiver em cache
   * @returns {Promise<Array>} Dados do enum
   */
  static async fetchEnum(enumName, forceRefresh = false) {
    if (!forceRefresh && enumCache.has(enumName)) {
      return enumCache.get(enumName);
    }

    try {
      const instance = getInstance();
      const response = await instance.get(`/BackofficeUtils/${enumName}`);
      const data = Array.isArray(response.data)
        ? sortFiltersByText(response.data, "description")
        : response.data;

      if (data) {
        enumCache.set(enumName, data);
      }
      return data;
    } catch (error) {
      return null;
    }
  }

  /**
   * Limpa o cache de enums
   */
  static clearCache() {
    enumCache.clear();
  }

  /**
   * Remove um enum específico do cache
   * @param {string} enumName - Nome do enum a ser removido
   */
  static removeFromCache(enumName) {
    enumCache.delete(enumName);
  }
}
